<div class="border-ace-grey-400 border-b" [class.hidden]="!showDefaultNav">
  <header class="font-body container bg-white relative !p-0 {{ activateMobileMenu ? '!fixed inset-0 !max-w-full w-full z-50 flex flex-col overflow-hidden' : '' }}">
    <skip-nav></skip-nav>
    <div [class.border-b]="activateMobileMenu">
      <div class="header-wrapper flex-wrap flex align-top !px-6"
        [class.!py-0]="activateMobileMenu"
        >
        <!-- Aceable logo -->
        <a href="/" class="mr-auto lg:mr-6 py-5" aria-label="Insurance Navigation Link">
          <img
            class="ace__nav-logo max-h-[44px]"
            src="{{ headerLogo }}"
            width="175"
            height="38px"
            alt="Aceable Insurance Logo (Header)"
            />
        </a>
        <!-- Default Nav -->
        <nav class="ace__nav hidden lg:flex flex-grow align-middle">
          @for (navLink of headerData; track navLink) {
            <ace-header-navlink [data]="navLink" class="flex items-center first:ml-0 mx-3">
            </ace-header-navlink>
          }
        </nav>
        <!-- Refer a Friend Pill (Desktop, logged-in only) -->
        @if (isLoggedIn) {
          <a
            href="https://insurance.aceable.com/referral/invite/"
            class="refer-a-friend-pill hidden lg:flex flex-col items-center justify-center self-center ml-auto"
            aria-label="Refer a Friend - Give $10, Get up to $25"
            >
            <span class="font-bold text-sm leading-tight">Refer a Friend</span>
            <span class="text-xs leading-tight">Give $10, Get up to $25</span>
          </a>
        }
        <!-- My Account Dropdown (not logged in) -->
        @if (!isLoggedIn) {
          <nav class="ace__nav hidden lg:flex align-middle">
            @for (navLink of myAccountData; track navLink) {
              <ace-header-navlink [data]="navLink"
                class="relative flex items-center my-account">
              </ace-header-navlink>
            }
          </nav>
        }
        <!-- User Initial Circle with Dropdown (logged in, desktop) -->
        @if (isLoggedIn) {
          <div
            class="hidden lg:flex items-center self-center ml-3 relative"
            (mouseenter)="showInitialDropdown = true"
            (mouseleave)="showInitialDropdown = false"
            >
            <span
              tabindex="0"
              class="user-initial-circle flex items-center justify-center cursor-pointer"
              (keydown.enter)="showInitialDropdown = !showInitialDropdown"
              aria-label="My Account"
            >{{ userInitial }}</span>
            <div
              class="z-30 absolute top-full right-0 py-v-spacing sm:px-v-spacing shadow-header bg-white rounded-b-md w-[180px] text-right"
              [class.hidden]="!showInitialDropdown"
              >
              @for (navLink of myAccountData; track navLink.linkLabel) {
                <div>
                  @for (link of navLink.ddList; track link.linkUrl; let last = $last) {
                    <div class="{{ last ? 'mb-0' : 'mb-4' }}">
                      <a class="text-base font-medium text-vis-regular hover:text-ace-teal-800 block w-full"
                        [href]="link.linkUrl"
                        tabindex="0"
                        >
                        <span [innerHTML]="link.linkLabel"></span>
                      </a>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        <!-- User Initial (Mobile, logged-in only) -->
        @if (isLoggedIn) {
          <span
            class="user-initial-circle flex lg:hidden items-center justify-center self-center mr-3"
            aria-label="Logged in user"
          >{{ userInitial }}</span>
        }
        <!-- Mobile Hamburger -->
        <button
          (click)="toggleMobileMenu()"
      class="
        text-ace-teal-800
        focus:outline-none
        font-body
        flex
        lg:hidden
        items-center
        self-center
      "
          >
          <img
            [attr.loading]="'eager'"
            width="32px"
            height="32px"
            class="w-8 h-8"
            [src]="activateMobileMenu ? 'https://xgrit-ecom.imgix.net/ace/X.svg?v=1712674314' : 'https://xgrit-ecom.imgix.net/ace/Hamburger-Menu.svg?v=1712674404'"
            [alt]="activateMobileMenu ? 'Close navigation menu' : 'Open navigation menu'"
            />
        </button>
      </div>
    </div>
    <!-- Mobile Nav Menu -->
    @if (activateMobileMenu) {
      <div
        class="ace__nav-mobile bg-white flex flex-col justify-items-start content-start lg:hidden relative flex-1 min-h-0 overflow-hidden"
        >
        <div class="flex-1 min-h-0 overflow-y-auto overscroll-contain">
          <div class="bg-white">
            @for (link of headerData; track link) {
              <collapse-link [link]="link"></collapse-link>
            }
            @for (link of myAccountData; track link) {
              <collapse-link [link]="link"></collapse-link>
            }
          </div>
          <div class="p-v-spacing">
            @if (!isLoggedIn) {
              <a
                href="https://app.aceable.com/user/signin?v=INS"
                class="ace__nav-sign-up secondary-button sm:w-fit"
                >
                Sign In
              </a>
            }
            @if (isLoggedIn) {
              <a
                href="https://insurance.aceable.com/referral/invite/"
                class="refer-a-friend-pill refer-a-friend-pill--mobile inline-flex items-center justify-center"
                aria-label="Refer a Friend - Give $10, Get up to $25"
                >
                <span class="font-bold text-sm">Refer a Friend</span>
                <span class="text-xs ml-1">- Give $10, Get up to $25</span>
              </a>
            }
          </div>
        </div>
      </div>
    }
  </header>
</div>
